<template>
  <div class="wrapper">
    <div class="header_wrapper">
      <v-toolbar color="primary" dark flat>
        <v-btn icon @click="routerBack">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-toolbar-title class="flex-grow-1 text-center ml-0" style="width: 100%">
          支払設定
        </v-toolbar-title>

        <v-btn icon disabled style="visibility: hidden">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-toolbar>
    </div>

    <div 
      v-if="loading" 
      class="d-flex justify-center align-center" 
      style="height: calc(100vh - 56px);"
    >
      <vue-loading
        loader="bars"
        :active="loading"
        color="#EE6090"
        :size="{ width: '30px', height: '30px' }"
      ></vue-loading>
    </div>

    <v-list v-else density="compact" class="content_wrapper pa-0">
      <template v-for="(p, index) in payments" :key="p.child.childId">
        
        <v-list-item
          @click="to(p.child.childId, p.child.lastName + p.child.firstName)"
        >
          <template v-slot:prepend>
            <v-avatar class="ml-2">
              <v-img
                :src="
                  p.child.imageUrl
                    ? p.child.imageUrl
                    : 'https://via.placeholder.com/240x180?text=Sample+Image+1'
                "
              />
            </v-avatar>
          </template>

          <v-list-item-title
            v-text="p.child.lastName + p.child.firstName"
          ></v-list-item-title>

          <v-list-item-subtitle
            class="text-grey body-2"
            v-text="getPaymentCategoryStr(p.category)"
          ></v-list-item-subtitle>

        </v-list-item>

        <v-divider />
      </template>
    </v-list>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

import { familyModule } from '@/store/entityModules/family';
import { paymentModule } from '@/store/entityModules/payment';

interface DataType {
  loading: boolean;
}

export default defineComponent({
  name: 'PaymentSelect',

  components: {
    'vue-loading': Loading,
  },

  data: () => ({
    loading: false,
  }),

  computed: {
    payments() {
      return paymentModule.payments;
    },
    family() {
      return familyModule.family;
    },
    children() {
      if (familyModule.family) {
        return familyModule.family.children;
      }
      return [];
    },
  },

  methods: {
    routerBack() {
      this.$router.replace('/setting/various');
    },
    to(childId: string, childName: string) {
      this.$router.push({
        name: 'Payment',
        query: {
          childId,
          childName,
        },
      });
    },
    getPaymentCategoryStr(category: string) {
      switch (category) {
        case 'card':
          return 'クレジットカード';
          break;

        case 'withdrawal':
          return '口座引き落とし';
          break;

        case 'invoice':
          return '振り込み';
          break;

        default:
          break;
      }
    },
    async fetchPaymentMethod() {
      if (this.family) {
        const familyId = this.family.familyId;
        this.loading = true;
        await paymentModule.fetchPaymentMethod({ familyId });
        this.loading = false;
      } else {
        this.routerBack();
      }
    },
  },

  mounted() {
    if (!this.family) {
      this.routerBack();
    }
    this.fetchPaymentMethod();
  },
});
</script>
<style lang="scss" scoped>
/* ===== レイアウト ===== */
.wrapper {
  padding-top: calc(var(--app-top-offset) + 56px); // ← ヘッダー分
  margin-bottom: calc(env(safe-area-inset-bottom) + 56px);
}

/* ===== ヘッダー ===== */
.header_wrapper {
  height: 56px;
  width: 100%;
  position: fixed;
  top: var(--app-top-offset); // ← 超重要
  left: 0;
  z-index: 100;

  .outline {
    border: 1px solid rgb(var(--v-theme-primary));
  }
}

/* ===== フォーム余白 ===== */
.v-form {
  margin-top: 8px;
}

/* ===== ラベルサイズ ===== */
.label-size > .v-input__control > .v-input__slot > .v-input--selection-controls__input > label {
  font-size: 12px;
}
// リストはヘッダー分だけ下げる
.v-list {
  margin-top: calc(env(safe-area-inset-top));
}
</style>
